export class WlChecked extends Event {
    public checked: boolean

    constructor(checked: boolean) {
        super('wl-checked', {bubbles: true, composed: true});
        this.checked = checked
    }
}